// Bound the complete lookup, including attestation. Late results belong only
// to the expired attempt and cannot resolve a subsequent retry.
export const ORGANIZATION_RESOLUTION_TIMEOUT_MS = 15000;
export function boundedOrganizationResolution(resolve, timeoutMs = ORGANIZATION_RESOLUTION_TIMEOUT_MS) {
  return new Promise((fulfill, reject) => {
    let settled = false;
    const timer = setTimeout(() => {
      settled = true;
      reject(Object.assign(new Error("Organization verification timed out. Please retry."), {code: "deadline-exceeded"}));
    }, timeoutMs);
    let operation;
    try { operation = resolve(() => !settled); }
    catch (error) { settled = true; clearTimeout(timer); reject(error); return; }
    Promise.resolve(operation).then(value => {
      if (!settled) { settled = true; clearTimeout(timer); fulfill(value); }
    }, error => {
      if (!settled) { settled = true; clearTimeout(timer); reject(error); }
    });
  });
}
